/* ============================================================================
 * Presence chain facts — ported from canon `apps/web/lib/contracts.ts`
 * ----------------------------------------------------------------------------
 * Presence runs on Base SEPOLIA (84532), not Base mainnet. The resolver is
 * testnet-only (`revert InvalidChainId when block.chainid != 84532`) and its
 * address is canon's literal string "TBD_DEPLOY_A5" — schemas are not
 * registered until Phase A5. NO address is invented here.
 * ========================================================================= */

import { baseSepolia } from 'wagmi/chains';

/** The canon chainId every Presence artifact agrees on. */
export const PRESENCE_CHAIN_ID = baseSepolia.id; // 84532

export const PRESENCE_CHAIN = {
  chainId: PRESENCE_CHAIN_ID,
  chainName: 'Base Sepolia',
  testnet: true,
  mainnet: false,
  /** official Base Sepolia public RPC — read-only, no key */
  rpcUrl: 'https://sepolia.base.org',
  /** canon literal — NOT a deployed address. Never silently substituted. */
  resolverAddress: 'TBD_DEPLOY_A5',
  explorer: 'https://sepolia.basescan.org',
} as const;

/** EAS deployments on Base Sepolia (canonical, same CREATE2 addresses as Base). */
export const PRESENCE_EAS_ADDRESSES = {
  eas: '0x4200000000000000000000000000000000000021',
  schemaRegistry: '0x4200000000000000000000000000000000000020',
  eip712Proxy: '0xF095fE4b23958b08D38e52d5d5674bBF0C03cbF6',
} as const;

/** True when an address value is not yet a real deployed address. */
export function isUnverifiedAddress(value: string): boolean {
  return !/^0x[0-9a-fA-F]{40}$/.test(value);
}

export function shortHex(value: string, head = 10, tail = 8): string {
  if (!value || value.length <= head + tail + 2) return value;
  return `${value.slice(0, head)}…${value.slice(-tail)}`;
}
